export class Paycard 
{
    public ID:string = '';
    public Timestamp:number = 0;
    public Number:number = 0;
    public Print:boolean = false;
    public Origin:number = 0;

    public OrderCount:number = 0;
    public LastOrderID:string = '';

    public Removed:boolean = false;
}
